import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Dialog = ({ className }) => {
  return (
    <svg
      viewBox='0 0 349 348'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classnames('icon', 'icon-dialog', { [className]: className })}
    >
      <path
        d='M46.3243 144.095H302.676V124.516H46.3243V144.095ZM46.3243 163.674H302.676V183.252H46.3243V163.674ZM46.3243 85.3582H302.676V104.937H46.3243V85.3582ZM46.3243 46.2006H302.676V65.7794H46.3243V46.2006ZM0 0V249.073H231.226L330.418 348H349V0H0ZM18.5815 230.541V18.5319H330.418V321.786L238.929 230.541H18.5815Z'
        fill='currentColor'
      />
    </svg>
  );
};

Dialog.propTypes = {
  className: PropTypes.string,
};

export default Dialog;
